/* eslint-disable import/prefer-default-export */
export const SET_CURRENT_MENU = 'SET_CURRENT_MENU';
